import { inject, Injectable } from '@angular/core';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environment } from '../../../environments/environment';
import { Observable, of, switchMap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ContractStatus, User } from './users.model';
import {Md5} from 'ts-md5';

export function getUsername(email: string): string {
  return Md5.hashStr(email.trim().toLowerCase());
}

function generateRandomString(length:number, charset: string): string {

    var result = '';
    for ( var i = 0; i < length; i++ ) {
        result += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return result;
}

export function generatePassword(): string {

  const length = 12 + Math.floor(Math.random() * 8);
  const split = 1 + Math.floor(Math.random() * (length - 1));
  

  const password = 
    generateRandomString(split, 'abcdefghijklmnopqrstuvwxyz') + 
    generateRandomString(length-split, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ') ;

  return password ;
}



@Injectable({
  providedIn: 'root'
})
export class UsersService {

  readonly http: HttpClient = inject(HttpClient) ; 
 

  async getUser(forceRefresh: boolean): Promise<User | undefined> {

    const session = await fetchAuthSession({forceRefresh}) ;
    
    const accessToken: any = session?.tokens?.accessToken ;
    const idToken: any = session?.tokens?.idToken ;
    if (!idToken || !accessToken) {
      return undefined ;
    }

    //console.log(idToken) ;
    const user = new User(
      //accessToken.payload.username, 
      idToken.payload.sub,
      idToken.payload.given_name, 
      idToken.payload.family_name,
      idToken.payload.email
    )
    user.profileImage = idToken.payload.picture ;
    user.bio = idToken.payload.profile ;

    return user ;
  }

  getContractStatus(): Observable<ContractStatus | undefined> {
    return this.http.get<ContractStatus>(`${environment.apiHost}/contracts/mine`) ;
  }

  public updateUser(user:User): Observable<User | undefined> {
    return this.http.patch<User>(
      `${environment.apiHost}/users`, 
      user
    ).pipe(
      switchMap((result: User) => {
        // Ensure session is updated after user update
        return this.getUser(true) ;
      })
    );
  }

  public postAvatar(img:any): Observable<User | undefined> {

    let fd = new FormData();
    fd.append('image', img);

    return this.http.post<User>(
      environment.apiHost + '/users/me/avatars',
      fd
    ).pipe(
      switchMap((result: User) => {
        // Ensure session is updated after user update
        return this.getUser(true) ;
      })
    );
  }

  public checkAccountExists(email: string): Observable<boolean> {

    return this.http.post<any>(
      `${environment.apiHost}/check-account`,
      { email: email }
    ).pipe(
      switchMap((result: any) => {
        return of(result.exists) ;
      })
    );
  }

  
}
